<form *ngIf="configForm" [formGroup]="configForm" (ngSubmit)="onSubmit(configForm)">
  <mat-card class="content-card">
    <mat-card-header>
      <mat-card-title>
        <h5>Order config</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-form-field>
        <mat-select placeholder="Card reorder template" formControlName="cardReorderTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Welcome template" formControlName="welcomeTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="TotalCard Info Template" formControlName="totalCardInfoTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Bulk order - Welcome template" formControlName="bulkWelcomeTemplateId">
          <mat-option [value]="-1">None</mat-option>
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Cash On Delivery - Welcome Template" formControlName="cashOnDeliveryWelcomeTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Order In Production template" formControlName="orderInProductionTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Order Activated template" formControlName="orderActivatedTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="Order Virtual template" formControlName="orderVirtualTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field>
        <mat-select placeholder="Order Shipped template" formControlName="orderShippedTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Order cancellation template" formControlName="orderCancellationTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Order cancellation template (from backend)" formControlName="orderInternCancellationTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Order cancellation success template" formControlName="orderCancellationSuccessTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-select placeholder="Order revocation template" formControlName="revocationTemplateId">
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>

    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-button type="submit" [disabled]="!configForm.valid || configForm.pristine">
        <mat-icon>done</mat-icon>
        <a>Save</a>
      </button>
    </mat-card-actions>
  </mat-card>
</form>
